import {Stack} from 'src/design/atoms/Stack';
import React from 'react';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {SidebarLinkItemTracker} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {ItemAssignmentsListByUser} from 'src/app/item-tracker/ItemAssignmentsListByUser';
import {ItemAssignmentsPendingReviewList} from 'src/app/item-tracker/ItemAssignmentsPendingReviewList';
import {itemTrackerDocumentTitle} from 'src/app/item-tracker/itemTrackerHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {useAppSelector} from 'src/redux/hooks';
import {CustomPermissions} from 'src/shared/auth/Constants/CustomPermissions';
import {useHasModulePermission} from 'src/shared/auth/useHasModulePermission';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const ItemTrackerDashboardPage: React.FC = () => {
  useSetDocumentTitle(itemTrackerDocumentTitle);
  const navigate = useAppNavigate();
  const {session} = useAppSelector(i => i.session);
  const userId = session?.user?.id;

  const {hasPermission: hasRequestItemsPermission} = useHasModulePermission({
    module: ModuleEnum.ItemTrackerAssignments,
    operation: PermissionOperationEnum.Custom,
    operationName: CustomPermissions.ItemTrackerItemRequest,
  });

  const handleRequestNewItems = () => {
    navigate(PathUtility.ItemTrackerRequest());
  };

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.ItemTracker}>
      {userId === undefined ? (
        <>Invalid User ID</>
      ) : (
        <Stack>
          <PageHeader>
            <PageHeader.Title icon={SidebarLinkItemTracker.icon}>
              Item Tracker
            </PageHeader.Title>
          </PageHeader>
          <ItemAssignmentsPendingReviewList
            titleText="My Pending Reviews"
            onNavigateTo={(itemDefinitionId, id) =>
              navigate(PathUtility.ItemTrackerReview(itemDefinitionId, id))
            }
          />

          <ItemAssignmentsListByUser
            titleText="My Assigned Items"
            assignedToUserId={userId}
            onNavigateTo={(itemDefinitionId, id) =>
              navigate(PathUtility.ItemTrackerView(itemDefinitionId, id))
            }
            onRequestItems={handleRequestNewItems}
            hasRequestItemsPermission={hasRequestItemsPermission}
          />
        </Stack>
      )}
    </ContentWrapper>
  );
};

export default ItemTrackerDashboardPage;

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.ItemTrackerDashboard(),
  element: <ItemTrackerDashboardPage />,
  isPrivate: true,
});
